import React, { useState } from "react";
import { Input, Button, Grid } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import ClientTable from "./levels/ClientTable";
import FolioTable from "./levels/FolioTable";
import SchemeTable from "./levels/SchemeTable";
import TransactionTable from "./levels/TransactionTable";

import ClientModal from "./modals/ClientModal";
import FolioModal from "./modals/FolioModal";
import SchemeModal from "./modals/SchemeModal";
import TransactionModal from "./modals/TransactionModal";

const { useBreakpoint } = Grid;

export default function LedgerView() {
  // 🔹 Search
  const [q, setQ] = useState("");

  // 🔹 Modal states
  const [clientModalOpen, setClientModalOpen] = useState(false);
  const [activeClient, setActiveClient] = useState(null);

  const [folioModalOpen, setFolioModalOpen] = useState(false);
  const [activeFolio, setActiveFolio] = useState(null);

  const [schemeModalOpen, setSchemeModalOpen] = useState(false);
  const [activeScheme, setActiveScheme] = useState(null);

  const [txnModalOpen, setTxnModalOpen] = useState(false);
  const [activeTxn, setActiveTxn] = useState(null);

  const screens = useBreakpoint();
  const navigate = useNavigate();
  const isMobile = !screens.md;

  return (
    <div style={{ padding: isMobile ? 12 : 24 }}>
      {/* 🔹 Header Back Button */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
        <Button
          icon={<ArrowLeftOutlined />}
          type="text"
          shape="circle"
          onClick={() => navigate("/dashboard")}
        />
      </div>

      {/* 🔹 Search Bar */}
      <Input
        allowClear
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search name, PAN, email, mobile"
        style={{ width: isMobile ? "100%" : 360, marginBottom: 12 }}
      />

      <h1 style={{ fontSize: isMobile ? 18 : 22, marginBottom: 12 }}>Client Ledger (Individual)</h1>

      {/* 🔹 Client Table */}
      <ClientTable
        searchQuery={q}
        onOpenModal={(record) => {
          setActiveClient(record);
          setClientModalOpen(true);
        }}
        // Folio Modal open
        onOpenFolioModal={(record) => {
          setActiveFolio(record);
          setFolioModalOpen(true);
        }}
        // Scheme Modal open
        onOpenSchemeModal={(record) => {
          setActiveScheme(record);
          setSchemeModalOpen(true);
        }}
        // Txn Modal open
        onOpenTxnModal={(record) => {
          setActiveTxn(record);
          setTxnModalOpen(true);
        }}
      />

      {/* 🔹 All Modals */}
      <ClientModal
        open={clientModalOpen}
        record={activeClient}
        onClose={() => {
          setClientModalOpen(false);
          setActiveClient(null);
        }}
        screens={screens}
      />

      <FolioModal
        open={folioModalOpen}
        record={activeFolio}
        onClose={() => {
          setFolioModalOpen(false);
          setActiveFolio(null);
        }}
        screens={screens}
      />

      <SchemeModal
        open={schemeModalOpen}
        record={activeScheme}
        onClose={() => {
          setSchemeModalOpen(false);
          setActiveScheme(null);
        }}
        screens={screens}
      />

      <TransactionModal
        open={txnModalOpen}
        record={activeTxn}
        onClose={() => {
          setTxnModalOpen(false);
          setActiveTxn(null);
        }}
        screens={screens}
      />
    </div>
  );
}
